import 'react-phone-number-input/style.css';
import './PhoneInput.css';

import { Input } from '@mantine/core';
import type { ReactNode } from 'react';
import { useController } from 'react-hook-form';
import type { FieldValues, UseControllerProps } from 'react-hook-form';
import PhoneInput from 'react-phone-number-input';
import type { DefaultInputComponentProps, FeatureProps } from 'react-phone-number-input';

import { parseError } from '../lib/parseError';

// DefaultInputComponentProps allows any prop as `any`, so label and onChange are typed here.
type PhoneNumberInputProps<T extends FieldValues> = UseControllerProps<T> &
  Omit<FeatureProps<DefaultInputComponentProps>, 'value' | 'defaultValue' | 'label' | 'onChange'> & {
    label?: ReactNode;
    onChange?: (phoneNumber: string) => void;
  };

export function PhoneNumberInput<T extends FieldValues>({
  name,
  control,
  defaultValue,
  rules,
  shouldUnregister,
  onChange,
  label,
  ...props
}: PhoneNumberInputProps<T>) {
  const {
    field: { value, onChange: fieldOnChange, ref: _fieldRef, ...field },
    fieldState,
  } = useController<T>({
    name,
    control,
    defaultValue,
    rules,
    shouldUnregister,
  });

  return (
    <Input.Wrapper error={parseError(label, fieldState.error)} label={label}>
      <PhoneInput
        international
        countrySelectProps={{ tabIndex: '-1' }}
        defaultCountry="NL"
        value={value}
        onChange={(phoneNumber = '') => {
          fieldOnChange(phoneNumber);
          onChange?.(phoneNumber);
        }}
        {...field}
        {...props}
      />
    </Input.Wrapper>
  );
}
